/** Shared physics tuning. Per-car overrides belong in content/registry.ts. */
export const PHYSICS_CONFIG = Object.freeze({
    grassWearRate: 3.2,
    gravelWearRate: 5.4,
    brakeWearRate: 3.5,
    wearCurve: 1.6,
    tireCriticalHealth: 15,
    criticalGripPenalty: 0.8,
    corneringWearRate: 0,
    minimumLateralGrip: 0.15,
    tireSteeringLoss: 0.12,
    tireTractionLoss: 0.3,
    tireCorneringStiffnessLoss: 1,
    tireSlideGripLoss: 0.9,
    asymmetricCorneringLoss: 0.25,
    grassLateralGrip: 0.28,
    grassPowerGripLoss: 0.65,
    wallRestitution: 0.08,
    wallMinimumReboundSpeed: 0.08,
    wallMaximumReboundSpeed: 0.65,
    wallSeparationDistance: 0.75,
    wallYawRetention: 0.25,
});
